export enum Language {
  English = 'EN',
  Swedish = 'SV',
  Danish = 'DA',
  Norwegian = 'NO',
  Finnish = 'FI',
  French = 'FR',
  DutchBE = 'NL_BE',
  Dutch = 'NL',
  German = 'DE',
}

export interface LanguageLabel {
  long: string;
  short: string;
}

export enum ApiStatus {
  Idle = 10,
  Started,
  Completed,
  Failed,
}

export type InvoiceState = 'overdue' | 'due-in' | 'new' | 'inProcess';
